export default () => ({
  show: false,
  seleted: -1,

  open(details) {
    if (this.show && this.seleted === details.index) {
      this.close();
    } else {
      this.show = true;
      this.seleted = details.index;
      Grebify.noScroll(true);
    }
  },

  close() {
    this.show = false;
    this.seleted = -1;
    Grebify.noScroll(false);
  },
});
